import { getTokenTemporary, getUserToken, getUserInfo } from '_utils/localData'
import { parseJwt } from '_utils/function'
import axiosClient from '_api/axiosClient'

const useHitpayRedirectUrl = () => {
  const getRedirectUrl = () => {
    let uidStr = ''

    const userInfo = getUserInfo()
    if (userInfo && userInfo.id) {
      uidStr = `&uid=${userInfo.id}`
    } else {
      let token = getTokenTemporary() || getUserToken()
      if (!token && axiosClient.defaults.headers.common.Authorization) {
        token = axiosClient.defaults.headers.common.Authorization.replace('Bearer ', '')
      }
      if (token) {
        try {
          const user = parseJwt(token)
          if (user && user.id) {
            uidStr = `&uid=${user.id}`
          }
        } catch (e) {}
      }
    }

    const { search } = window.location
    return `${window.location.origin}/payment-order${search}${uidStr}`
  }

  return { getRedirectUrl }
}

export default useHitpayRedirectUrl
